import { getSupabaseBaseUrl, getSupabasePublishableKey } from '@/lib/selfHostedUrls';
import { createGovernedBrowserClient } from './portalClientFactory';

const SUPABASE_URL = getSupabaseBaseUrl();
const SUPABASE_PUBLISHABLE_KEY = getSupabasePublishableKey();

// Separate Supabase client for the Super Admin portal with an isolated storage key.
// This prevents session conflicts when an admin is also logged into ForkHire or ForkSeek.
export const adminSupabase = createGovernedBrowserClient(
  'admin',
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
);
